import { StatusBasicEnum } from "../generated/api"
import { BASIC_STATUS } from "../types/_enums"
import { IssuerEditorForm } from "../types/Issuers"
import { Organization } from "../types/Organization"
import { EUDirectiveModalProps } from "../types/OrganizationContact"

const INITIAL_ORG_MODAL_STATE: Organization = {
  approvedBy: null,
  approvedDate: null,
  financeHold: false,
  firstCreatedBy: null,
  firstCreatedDate: "",
  lastUpdatedBy: null,
  lastUpdatedDate: null,
  mpid: null,
  organizationId: 0,
  organizationName: "",
  status: BASIC_STATUS.INACTIVE
}

export const INITIAL_ISSUER_STATE = {
  description: "",
  firstCreatedBy: "",
  firstCreatedDate: "",
  headquartersLocationAddress: {
    street1: "",
    street2: "",
    city: "",
    state: "",
    country: "",
    postalCode: ""
  },
  inBusinessSince: "",
  investorRelationsPhone: "",
  issuerCode: "",
  issuerCusip: "",
  issuerId: 0,
  issuerName: "",
  lastUpdatedBy: "",
  lastUpdatedDate: "",
  organizationId: 0,
  stageFirstCreatedBy: "",
  stageFirstCreatedDate: "",
  Status: StatusBasicEnum.Inactive,
  totalAssetsUnderManagement: "",
  totalAssetsUnderManagementDate: "",
  webSite: "",
  investorRelationsEmail: "",
  organizationName: "",
  issuerAccountNumber:'',
  excludeFromWdTransfer: false
}

export const IsserEditorFormInitialValues: IssuerEditorForm = {
  description: "",
  inBusinessSince: "",
  investorRelationsEmail: "",
  investorRelationsPhone: "",
  issuerCode: "",
  issuerCusip: "",
  totalAssetsUnderManagement: "",
  totalAssetsUnderManagementDate: "",
  investorInvestedAssets: "",
  webSite: "",
  city: "",
  state: "",
  country: { name: "", code: "" },
  issuerAccountNumber: ""
  // region: { name: "", code: "" },
  // postalCode: ""
}

export const INITIAL_EU_DIRECTIVE_MODAL_STATE : EUDirectiveModalProps = {
  isOpen : false,
  toggle : () => {},
  onSubmit : () => {},
  isLoading : false 
}

export default INITIAL_ORG_MODAL_STATE
